<template>
  <div id="container" type="vsearch_state">
    <div class="page page-searchstate" v-ga:request="{ pageType: glb.pageType }" v-ga:page="{ pageType: glb.pageType, glb: glb }">
      <mvtHeader :geoInfo="glb.geo" />
      <aside class="page-map"><mvtNewMap id="map" ref="map" v-if="loadMap" @centerChanged="onCenterChanged" :center="center" :zoom="zoom" :boundaryIndexId="getBoundaryIndexId"></mvtNewMap><button v-if="geoBoundaryIndexId || hasMapChanged" type="button" @click="resetMap()" class="map-button btn small filter">{{molang('searchState.reset')}}</button></aside>
      <main class="page-content">
        <section class="m-t-0">
          <div class="m-b-3">
            <mvtBreadcrumb :geo="glb.geo" :forceSitemapPath="true" />
          </div>
          <div class="panel">
            <h1 class="f1 text-bold">{{ getSeo.h1 }}</h1>
            <p>{{molang('searchState.find_the_newest_homes_for_sale_in')}} {{ glb.geo.stateFullName }} by choose from the list of cities and counties below.</p>
          </div>
        </section>
        <section class="nearby-cities" v-if="getTopCities && getTopCities.length">
          <h2 class="f3 text-bold">{{molang('searchState.top_cities_in')}} {{ glb.geo.stateFullName }}</h2>
          <mvtShifter>
              <div v-for="city in getTopCities" class="panel-card vertical" :key="city.path">
                <div class="profile">
                  <img class="bg" :src="`https://assets.movoto.com/novaimgs/staticmaps/${city.boundaryIndexId}.webp`" loading="lazy" :alt="`${city.name} ${molang('searchState.real_estate')}`" />
                  <button class="btn-switch circle toggle" type="button" @click="switchMap(city.boundaryIndexId, city.lat, city.lng)"><i class="icon-map f3"></i></button>
                </div>
                <h3 class="f4 text-bold">{{ city.name }}</h3>
                <div class="f6">{{molang('searchState.average_price')}} {{ $filters.formatFriendlyPrice(city.avgPrice) }}</div>
                <div class="f6">{{molang('searchState.average_price_per_sqft')}} {{ $filters.formatPrice(city.avgPricePerSqft) }}</div>
                <div class="f6">{{molang('searchState.average_days_on_market')}} {{ city.avgDom }}</div>
                <a class="btn small thrid" :href="`${glb.appUrl}${glb.language==='es' ? 'es/' : ''}${city.path}`">{{molang('searchState.view')}} {{ $filters.formatNumber(city.count) }} {{molang('searchState.homes')}}</a>
                <div class="tag-panel">
                  <div class="tag-group left" tabindex="-1">
                    <span class="tag custom pricecut-tag">
                      <template  v-if="!city.isReduce" >
                        <span class="price-reduced"><i class="icon-send-ios"></i>{{molang('searchState.demand')}}</span>
                      </template>
                      <template v-else>
                        <span class="price-increased"><i class="icon-arrow-down-circle-filled"></i>{{molang('searchState.demand')}}</span>
                      </template>
                    </span>
                  </div>
                </div>
              </div>
          </mvtShifter>
        </section>
        <section v-if="getCities && getCities.length">
          <h2 class="f3 text-bold">{{molang('searchState.all_cities_in')}} {{ glb.geo.stateFullName }}</h2>
          <div class="text-gray f6">{{molang('searchState.data_based_on_current_averages')}}</div>
          <div class="search-table" :class="showAllCities ? 'show-all' : ''">
            <table class="f6">
              <thead>
                <tr>
                  <th></th>
                  <th><span>{{molang('searchState.price')}}</span></th>
                  <th><span>{{molang('searchState.price_per_sqft')}}</span></th>
                  <th><span>{{molang('searchState.days_on_market')}}</span></th>
                  <th><span>{{molang('searchState.inventory')}}</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="city in getCities" :key="city.path">
                  <td>
                    <a class="link" :href="`${glb.appUrl}${glb.language==='es' ? 'es/' : ''}${city.path}`">{{ city.name }} {{molang('searchState.homes_for_sale')}}</a> <i class="icon-send-ios text-safe" v-if="!city.isReduce"></i> <i class="icon-arrow-down-circle-filled text-danger" v-else></i>
                  </td>
                  <td>
                    {{ $filters.formatFriendlyPrice(city.avgPrice) }}
                  </td>
                   <td>
                    {{ $filters.formatPrice(city.avgPricePerSqft) }}
                  </td>
                  <td>
                    {{ city.avgDom }}
                  </td>
                  <td>
                    {{ $filters.formatNumber(city.count) }}
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="getCities.length > 10">
                <tr><td>
                  <button type="button" class="text-brand text-bold" @click="toggleCities">{{ showAllCities ? molang('searchState.view_less') : molang('searchState.view_more')}} <i class="icon-angle-up"></i></button>
                </td></tr>
              </tfoot>
            </table>
          </div>
        </section>
        <section>
          <h2 class="f3 text-bold">{{molang('searchState.newest_homes_for_sale')}} {{ glb.geo.stateFullName }} {{molang('searchState.homes_for_sale')}}</h2>
          <mvtNearby type="filterPath" :data="getNearbyHomes" :filterPath="`${glb.geo.stateCode}/new-7/pagesize-10/`"></mvtNearby>
        </section>
        <section v-if="getCounties && getCounties.length">
            <h2  class="f3 text-bold">{{molang('searchState.all_counties_in')}} {{ glb.geo.stateFullName }}</h2>
            <div class="text-gray f6">{{molang('searchState.data_based_on_current_averages')}}</div>
            <div class="search-table" :class="showAllCounties ? 'show-all' : ''">
              <table class="f6">
                <thead>
                  <tr>
                    <th></th>
                    <th><span>{{molang('searchState.price')}}</span></th>
                    <th><span>{{molang('searchState.price_per_sqft')}}</span></th>
                    <th><span>{{molang('searchState.days_on_market')}}</span></th>
                    <th><span>{{molang('searchState.inventory')}}</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="county in getCounties" :key="county.path">
                    <td>
                      <a class="link" :href="`${glb.appUrl}${glb.language==='es' ? 'es/' : ''}${county.path}`">{{ county.name }} {{molang('searchState.homes_for_sale')}}</a> <i class="icon-send-ios text-safe" v-if="!county.isReduce"></i> <i class="icon-arrow-down-circle-filled text-danger" v-else></i>
                    </td>
                    <td>
                      {{ $filters.formatFriendlyPrice(county.avgPrice) }}
                    </td>
                    <td>
                      {{ $filters.formatPrice(county.avgPricePerSqft) }}
                    </td>
                    <td>
                      {{ county.avgDom }}
                    </td>
                    <td>
                      {{ $filters.formatNumber(county.count) }}
                    </td>
                  </tr>
                </tbody>
                <tfoot v-if="getCounties.length > 10">
                  <tr><td>
                    <button type="button" class="text-brand text-bold" @click="toggleCounties">{{ showAllCounties ? molang('searchState.view_less') : molang('searchState.view_more')}} <i class="icon-angle-up"></i></button>
                  </td></tr>
                </tfoot>
              </table>
            </div>
        </section>
      </main>
      <mvtFooter :geoInfo="glb.geo" />
    </div>
    <mvtPopSignin />
    <mvtDialogCenter></mvtDialogCenter>
  </div>
</template>
<script src="./page-searchstate.js"></script>
<style lang="scss">
@use "./page-searchstate.scss" as *;
</style>